<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <custom-divider label="تنظیمات ایمیل"></custom-divider>
                <p class="my-2 text-small text-grey-darken-1">برای ارسال اطلاعیه رویدادهای سامانه اطلاعات سرور ایمیل سازمانی خود را وارد فرمایید.<br>چنانچه تنظیمات ایمیل شما دارای دو مقدار متفاوت برای نام کاربری و ایمیل هست هر دو گزینه را وارد نموده و در غیر این صورت، آدرس ایمیل را در فیلد نام کاربری وارد کرده و ایمیل ارسال کننده را خالی رها کنید.<br>توجه: پیش از ارسال تست، دکمه ثبت اطلاعات در پایین این صفحه را کلیک کنید تا تنظیمات فعلی شما ذخیره گردد.</p>
                <v-row class="mt-4" dense>
                    <v-col cols="9">
                        <v-text-field
                            :rules="$validation('url')"
                            label="آدرس سرور SMTP"
                            v-model="form.email_server_address"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            :rules="$validation()"
                            label="پورت SMTP"
                            v-model="form.email_server_port"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="نام کاربری"
                            v-model="form.email_username"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="ایمیل ارسال کننده"
                            v-model="form.email_from"
                        ></v-text-field>
                    </v-col>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="کلمه عبور"
                            v-model="form.email_password"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation('email')"
                            label="آدرس ایمیل ارسال آزمایشی"
                            v-model="testEmail"
                            ref="testEmail"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="secondary" :loading="testEmailLoading" :disabled="!testEmail || !$refs.testEmail?.isValid" @click="sendTestEmail">
                            <span class="text-small font-weight-medium">ارسال ایمیل آزمایشی</span>
                        </v-btn>
                    </v-col>
                </v-row>
                <custom-divider label="تنظیمات پنل پیامکی"></custom-divider>
                <p class="mb-4 text-small text-grey-darken-1">چنانچه تمایل دارید رویدادهای مهم سامانه به ویژه موارد مرتبط با تیکت‌ها از طریق پیامک نیز به کاربران شما اطلاع‌رسانی شود نوع سامانه پیامکی خود را از لیست زیر انتخاب نموده و تنظیمات تکمیلی را اعمال نمایید. پیکر بندی سامانه های پیامکی در بخش <span class="cursor-pointer user-select-none-none text-decoration-underline" @click="$router.push({path: '/settings/plugins'})">افزونه ها</span> در دسترس شما می باشند.<br>توجه: پیش از ارسال تست، دکمه ثبت اطلاعات در پایین این صفحه را کلیک کنید تا تنظیمات فعلی شما ذخیره گردد.</p>
                <v-select
                    :rules="$validation()"
                    label="پنل پیامکی"
                    item-title="name"
                    no-data-text="موردی پیدا نشد!"
                    item-value="id"
                    :items="smsPanels"
                    v-model="form.sms_panel"
                    clearable
                ></v-select>
                <v-row dense>
                    <v-col>
                        <v-text-field
                            :rules="$validation()"
                            label="شماره گیرنده"
                            v-model="testSMS"
                            ref="testSMS"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="secondary" :loading="testSmsLoading" :disabled="!testSMS || testSMS.length !== 11 || !$refs.testSMS?.isValid" @click="sendTestSms">
                            <span class="text-small font-weight-medium">ارسال پیامک آزمایشی</span>
                        </v-btn>
                    </v-col>
                </v-row>
                <div v-if="$system.license.features.notice_webhook">
                    <custom-divider label="تنظیمات Webhook"></custom-divider>
                    <p class="mb-4 text-small text-grey-darken-1">سامانه هلپیکال این قابلیت را دارد که رویدادهای مرتبط با تیکت‌ها و کاربران را از طریق پروتکل HTTP اطلاع‌رسانی نماید. برای استفاده از این ویژگی آدرس URL دریافت کننده این پیغام‌ها را در فرم زیر وارد نمایید. برای احراز هویت پیام‌های ارسالی از سامانه هلپیکال، تنظیم کلید محرمانه اکیدا توصیه می‌گردد.<br>توجه: پیش از ارسال تست، دکمه ثبت اطلاعات در پایین این صفحه را کلیک کنید تا تنظیمات فعلی شما ذخیره گردد.</p>
                    <v-text-field
                        :rules="$validation()"
                        label="کلید محرمانه ارتباط با Webhook"
                        v-model="form.webhook_secret_key"
                        class="arial-input"
                        readonly
                    >
                        <template #append-inner>
                            <v-icon class="cursor-pointer me-2 position-relative z-index-9" color="primary" @click="form.webhook_secret_key = null" v-if="form.webhook_secret_key">clear</v-icon>
                            <v-icon v-if="form.webhook_secret_key" @click="$text.copy(form.webhook_secret_key)" class="cursor-pointer me-2" color="primary" size="21">content_copy</v-icon>
                            <v-icon class="cursor-pointer position-relative mx-1 z-index-9" color="primary" @click="form.webhook_secret_key = uuid()">refresh</v-icon>
                        </template>
                    </v-text-field>
                    <v-row dense>
                        <v-col>
                            <v-text-field
                                :rules="$validation('url')"
                                label="آدرس سرور Webhook"
                                v-model="form.webhook_address"
                                ref="webhookAddress"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn color="secondary" :disabled="!form.webhook_address">
                                <span class="text-small font-weight-medium">درخواست آزمایشی</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <div class="mt-4">
                    <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
export default {
    title: "تنظیمات عمومی اطلاع‌رسانی",
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            testWebhookLoading: false,
            testEmailLoading: false,
            testSmsLoading: false,
            testEmail: null,
            testSMS:null,
            formPermissionList: {
                webhook_address: this.$system.license.features.notice_webhook,
                webhook_secret_key: this.$system.license.features.notice_webhook,
            },
            form: {
                email_server_address: this.$system.settings.email_server_address,
                email_server_port: !this.$system.settings.email_server_port ? 465 : this.$system.settings.email_server_port,
                email_username: this.$system.settings.email_username,
                email_from: this.$system.settings.email_from,
                email_password: this.$system.settings.email_password,
                sms_panel: this.$system.settings.sms_panel,
                webhook_address: null,
                webhook_secret_key: null,
            },
            smsPanels: [
                { id: "helpical", name: "هلپیکال" },
                { id: "meli_payamak", name: "ملی پیامک" },
                { id: "kavenegar", name: "کاوه نگار" },
                { id: "sms_ir", name: "SMS.IR" },
                { id: "magfa", name: "مگفا" },
                { id: "url_base", name: "ارسال SMS از طریق URL" },
            ],
        };
    },
    methods: {
        uuid() {
          return uuidv4().toUpperCase();
        },
        sendTestSms() {
            this.testSmsLoading = true;
            this.$testSMS(this.testSMS).then(res => {
                if (res && res.status == 'OK')
                    this.$toast.success(res.message)
                else
                    this.$toast.error(res.message)
            }).finally(() => this.testSmsLoading = false)
        },
        sendTestEmail() {
            this.testEmailLoading = true;
            this.$testEmail(this.testEmail).then(res => {
                if (res && res.status == 'OK')
                    this.$toast.success(res.message)
                else
                    this.$toast.error(res.message)
            }).finally(() => this.testEmailLoading = false)
        },
        sendTestWebhook() {
            this.testWebhookLoading = true;
            this.$testWebhook().then(res => {
                if (res && res.status == 'OK')
                    this.$toast.success(res.message)
                else
                    this.$toast.error(res.message)
            }).finally(() => this.testWebhookLoading = false)
        },
        submit() {
            this.loading = true;
            this.$updateSettings({...this.form, _method: 'put'}).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
    },
    created() {
        for (const key in this.formPermissionList) {
            if (this.formPermissionList[key])
                this.form[key] = Array.isArray(this.$system.settings[key]) ? [...this.$system.settings[key]] : this.$system.settings[key];
            else
                delete this.form[key];
        }
    }
};
</script>
